/* Venues — STORY-013.
 *
 * A saved record rather than free text on an Event, so that one place is one
 * thing — and the place an Event's timezone comes from.
 */
import * as z from 'zod';
export const VENUE_NAME_MAX = 120;
export const venueSchema = z.object({
    id: z.string(),
    name: z.string(),
    /**
     * The IANA identifier, or null.
     *
     * Null is a real answer, not a missing one: a Venue with no zone falls back
     * to the Organisation's, and so does an Event with no Venue. Resolved on
     * read, never stored on the Event — EPIC-002 risk 2.
     */
    timezone: z.string().nullable(),
    /** Offered in pickers. False hides it from new Events and changes nothing else. */
    available: z.boolean(),
    /**
     * How many Events are held here.
     *
     * Derived on every read. It is what the list shows, and what the refusal to
     * delete counts — a number that would go wrong quietly if it were stored.
     */
    eventCount: z.number().int().nonnegative(),
});
export const venuesResponseSchema = z.object({ venues: z.array(venueSchema) });
export const createVenueRequestSchema = z.object({
    /* Trimmed before the length is judged. Two names differing only by padding
     * are one name — that is the fragmentation this record exists to prevent. */
    name: z.string().trim().min(1).max(VENUE_NAME_MAX),
    timezone: z.string().min(1).nullish(),
});
/**
 * Editing one. Absent leaves a field alone; `null` clears the timezone.
 *
 * The same distinction the Event PATCH rests on, and for the same reason:
 * a body with no absent keys turns every save of the name into a save of
 * everything else.
 */
export const updateVenueRequestSchema = z.object({
    name: z.string().trim().min(1).max(VENUE_NAME_MAX).optional(),
    timezone: z.string().min(1).nullish(),
    available: z.boolean().optional(),
});
//# sourceMappingURL=venues.js.map